import React, { useEffect, useState } from "react";
import "./Statements.css";
import { AbstructVar } from "../../../components/general/general-component/abstruct-component/AbstructVar";
import OneExpenses from "./OneExpenses";
import { AbstructLang } from "../../../components/general/general-component/abstruct-component/AbstructLang";
import AddExpenses from "../expenses/AddExpenses";
import { useParams } from "react-router-dom";
import {
  emptyOneStatement,
  loadOneStatement,
} from "../../../store/Actions/ActionStatements";
import { useSelectorCustom } from "../../../components/general/general-component/abstruct-component/useSelectorCustom";
import InnerLoader from "../../../components/general/inner-loader/InnerLoader";
import {
  UsePermissions,
  hasPermissions,
} from "../../../components/general/general-component/abstruct-component/UsePermissions";
import CheckPermissions from "../../../components/general/general-component/check-permissions";
import moment from "moment";
import { exportExpenses } from "../../../store/Actions/ActionExpenses";

function StatementsExpenses() {
  const { permissionss, loadingMainPermission } = UsePermissions();
  const expenses_statements = hasPermissions(
    [{ name: "expenses-statements" }],
    permissionss
  );
  let { id } = useParams();
  const { dispatch, langLocal, navigate } = AbstructVar();
  const { translate } = AbstructLang();
  const [openExpenses, setOpenExpenses] = useState(false);
  const { one_statement, loadingOneStatement } = useSelectorCustom();
  const [loadExport, setLoadExport] = useState(false);

  const openAddExpenses = (e) => {
    e.preventDefault();
    setOpenExpenses(true);
  };

  const Export = (e) => {
    e.preventDefault();
    if (one_statement.id !== "" && one_statement.account.id !== "") {
      dispatch(
        exportExpenses(
          "",
          "",
          one_statement.id,
          "",
          one_statement.account.id,
          setLoadExport
        )
      );
    }
  };

  useEffect(() => {
    dispatch(loadOneStatement(id));
    return () => {
      dispatch(emptyOneStatement());
    };
  }, []);

  return (
    <CheckPermissions
      array={expenses_statements}
      loadingMainPermission={loadingMainPermission}
    >
      <main>
        <div
          className="div_table margin_main shadow_main"
          dir={langLocal == "ar" ? "rtl" : "ltr"}
        >
          {loadingOneStatement ? (
            <InnerLoader />
          ) : (
            <div className="statment-expenses">
              <div className='d-flex' style={{ justifyContent: "space-between" }} >
                                    <h3>{translate('daily_expense_statement')}</h3>
                                    <button className='btn-savee' onClick={Export} > {translate('export')}</button>
                                </div>
              <div className="top-statment-expenses">
                <div className="one-top-statment-expenses">
                  <span className="title-statment-expenses">
                    {translate("series_name")}
                  </span>
                  <span className="sub-title-statment-expenses">
                    {one_statement?.project?.name}
                  </span>
                </div>
                <div className="one-top-statment-expenses">
                  <span className="title-statment-expenses">
                    {translate("account_name")}
                  </span>
                  <span className="sub-title-statment-expenses">
                    {one_statement?.account?.name}
                  </span>
                </div>
                <div className="one-top-statment-expenses">
                  <span className="title-statment-expenses">
                    {translate("created_by")}
                  </span>
                  <span className="sub-title-statment-expenses">
                    {one_statement?.created_by?.name}
                  </span>
                </div>
                <div className="one-top-statment-expenses">
                  <span className="title-statment-expenses">
                    {translate("created_at")}
                  </span>
                  <span className="sub-title-statment-expenses">
                    {moment(one_statement?.created_at).format("YYYY-MM-DD")}{" "}
                  </span>
                </div>
              </div>
              <div className="all-expenses">
                {one_statement?.expenses?.map((expense, index) => {
                  return (
                    <OneExpenses
                      langLocal={langLocal}
                      index={index}
                      expense={expense}
                    />
                  );
                })}
              </div>
            </div>
          )}
        </div>
        {openExpenses && (
          <AddExpenses
            viewExpenses="yes"
            statement_id={id}
            isStatment={false}
            open={openExpenses}
            setOpen={setOpenExpenses}
          />
        )}
      </main>
    </CheckPermissions>
  );
}

export default StatementsExpenses;
